module.exports = __webpack_public_path__ + "assets/img/people.83abae10.png";